import React, { useEffect, useState } from 'react'
import MyPlansView from './MyPlansView'
import crmservices from '../../wsclient';
import { custom_page } from '../../custom.config';
import { useLocation, useSearchParams } from 'react-router-dom';
import { cache } from '../../utils/cache';

const MyPlansPage = custom_page.my_plans && custom_page.my_plans.view ? require('../../custom_src/pages/my-plans/MyPlansController').default : MyPlansView;

export default function MyPlansController(props) {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const fromMenuProfile = location && location.state && location.state.from == 'menu_profile' ? true : false;
    let isOpenPaymentMethod = location && location.state && location.state.isOpenPaymentMethod ? location.state.isOpenPaymentMethod : false;
    let fromSpend = (location && location.state && location.state.from == 'spend') ? true : false;
    const [showLoadingServices, setShowLoadingServices] = useState(false);
    const [showLoadingCommunities, setShowLoadingCommunities] = useState(false);
    const [showLoadingDonations, setShowLoadingDonations] = useState(false);
    const [totalService, setTotalService] = useState();
    const [totalCommunities, setTotalCommunities] = useState({
        joined: 0,
        owner: 0
    });
    const [subscriptions, setSubscriptions] = useState([]);
    const [donations, setDonations] = useState([]);
    const [groups , setGroups] = useState([]);
    const [totalCommunitiesCombinedNumber, setTotalCommunitiesCombinedNumber] = useState(0);

    if(searchParams.get("add_funding_method") && searchParams.get("add_funding_method") == "true")
    {
        fromSpend = true;
        isOpenPaymentMethod = true;
    }

    useEffect(() => {
        const loadAllData = async () => {
            setShowLoadingCommunities(true);
            try {
                if (!fromMenuProfile) {
                    await Promise.all([onLoadSubscriptions(), onLoadMyDonations()]);
                }
            
                const [myGroups, joinedCommunities] = await Promise.all([
                    onLoadMyGroups(),
                    onLoadJoinedCommunities()
                ]);
            
                // Assuming these return arrays
                const total = myGroups.length + joinedCommunities.length;
                setTotalCommunitiesCombinedNumber(total);
            } catch (error) {
                console.error("Error loading initial data:", error);
            } finally {
                setShowLoadingCommunities(false);
            }
        };
        loadAllData();
    }, [])

    
    const onLoadMyGroups = async () => {
        let groups;
        try {
            const result = await crmservices.communitity.getContactGroups();
            if (result.code === 'OK') {
                const myGroups = result.data.groups.map((item) => ({
                    group: item,
                    isOwner: true,
                    ownerId: cache.getContact().id
                }));
                setGroups(prev => [...prev, ...myGroups]);
                setTotalCommunities({
                    joined: 0,
                    owner: myGroups.length
                });
                groups = myGroups;
            }
        } catch (error) {
            console.log("onLoadCommunities error:", error);
        }
        return groups;
    };
        
    const onLoadJoinedCommunities = async () => {
        let joinedCommunities;
        try {
            const result = await crmservices.communitity.getListJoinedCommunities();
            if (result.code === 'OK' && result.data.content) {
                const joinedGroups = result.data.content.map((item) => ({
                    group: item.group,
                    isOwner: false,
                    ownerId: item.community_owner.id,
                    ownerName : item.community_owner.first_name + (item.community_owner.last_name ? " " + item.community_owner.last_name : ""),
                }));
                setGroups(prev => [...prev, ...joinedGroups]);
                setTotalCommunities((prev) => ({
                    ...prev,
                    joined: joinedGroups.length
                }));
                joinedCommunities = joinedGroups;
            }
        } catch (error) {
            console.log("onLoadJoinedCommunities error:", error);
        }
        return joinedCommunities;
    };

    const onLoadSubscriptions = async () => {
        setShowLoadingServices(true);
        try {
            let result = await crmservices.subscriptions.getListSubscriptions({
                include_billing_info: true,
                include_terms: true,
            });
            if(result.code == "OK") {
                if(result.data && result.data.content) {
                    setSubscriptions(result.data.content);
                    let _totalServices = {
                        total_subscription: 0,
                        total_service: 0,
                    }
                    let total_service = 0;
                    let total_subscription = 0;
                    result.data.content.forEach(item => {
                        if(item.state != 'CHURNED') {
                            total_subscription += 1;
                            total_service += item.active_services + item.inactive_services + item.draft_services;
                        }
                    });
                    _totalServices.total_service = total_service;
                    _totalServices.total_subscription = total_subscription;
                    setTotalService(_totalServices);
                }
            }
        } catch (ex) {
        }
        setShowLoadingServices(false);
    }
    const onLoadMyDonations = async () => {
        setShowLoadingDonations(true);
        try {
            let result = await crmservices.contacts.getContactDonationsOffer({ size: 4 });
            if(result.code == 'OK') {
                setDonations(result.data && result.data.content ? result.data.content : []);
            }
        } catch (error) {
        }
        setShowLoadingDonations(false);
    }

    const onRefreshCommunities = async () => {
        onLoadJoinedCommunities();
    }

    return (
        <MyPlansPage
            showLoadingCommunities={showLoadingCommunities}
            showLoadingServices={showLoadingServices}
            totalService={totalService}
            totalCommunities={totalCommunities}
            totalCommunitiesCombinedNumber={totalCommunitiesCombinedNumber}
            subscriptions={subscriptions}
            fromMenuProfile={fromMenuProfile}
            isOpenPaymentMethod={isOpenPaymentMethod}
            onRefreshCommunities={onRefreshCommunities}
            onRefreshSubscriptions={onLoadSubscriptions}
            showLoadingDonations={showLoadingDonations}
            myDonations={donations}
            fromSpend={fromSpend}
            groups={groups}
        />
    )
}
